import { render, staticRenderFns } from "./ent-project.vue?vue&type=template&id=13b7a060&scoped=true&"
import script from "./ent-project.vue?vue&type=script&lang=js&"
export * from "./ent-project.vue?vue&type=script&lang=js&"
import style0 from "./ent-project.vue?vue&type=style&index=0&id=13b7a060&scoped=true&lang=css&"
import style1 from "./ent-project.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b7a060",
  null
  
)

export default component.exports